const transfeeraData = {
  COMPANY_NAME: 'Transfeera Serviços de Pagamento LTDA.',
  COMPANY_ID: 'b3b5699a-232c-4874-b669-201b711e8061',
  CNPJ: '27.084.098/0001-69',
  ISPB: '27084098',
  DEFAULT_PIX_KEY: 'pix@transfeera.com'
};

module.exports = transfeeraData;
